import React from 'react';
import StartseitenHeader from '../components/dashboard/startseite/StartseitenHeader';

const DashboardIntro = () => {
  return (
    <>
      <StartseitenHeader />
    </>
  );
};

export default DashboardIntro;
